import { render, staticRenderFns } from "./DiskUsageTab.vue?vue&type=template&id=008b2e6f&scoped=true&"
import script from "./DiskUsageTab.vue?vue&type=script&lang=ts&"
export * from "./DiskUsageTab.vue?vue&type=script&lang=ts&"
import style0 from "./DiskUsageTab.vue?vue&type=style&index=0&id=008b2e6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b2e6f",
  null
  
)

export default component.exports